export default "__VITE_ASSET__fa0afe97__"